import React from 'react';
import { Box, Typography, Stack, Button, Chip, Avatar } from '@mui/material';
import { Link } from 'react-router-dom';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { useAuth } from '../../../context/AuthContext';
import { t } from '../../../utils/textUtils';
import { getRoleConfig } from '../../../utils/roleConfig';

const DashboardHeader = () => {
  const { user } = useAuth();
  const displayName = user?.fullName || user?.name || t('USER');
  const roleConfig = getRoleConfig(user?.role);
  const initials = displayName.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
  const firstName = displayName.split(' ')[0];
  const firstNameCapitalized = firstName ? firstName.charAt(0).toUpperCase() + firstName.slice(1) : firstName;

  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
  });

  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 60%, #1e40af 100%)',
        borderRadius: 3,
        mb: 3,
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      {/* Decorative circles */}
      <Box sx={{
        position: 'absolute', top: -40, right: -40,
        width: 200, height: 200, borderRadius: '50%',
        background: 'rgba(255,255,255,0.04)', pointerEvents: 'none'
      }} />
      <Box sx={{
        position: 'absolute', bottom: -60, right: 80,
        width: 150, height: 150, borderRadius: '50%',
        background: 'rgba(255,255,255,0.03)', pointerEvents: 'none'
      }} />

      <Box sx={{ p: { xs: 2.5, sm: 3.5 }, position: 'relative', zIndex: 1 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'flex-start', sm: 'center' }} spacing={2}>
          {/* Left: Identity */}
          <Stack direction="row" spacing={2} alignItems="center">
            <Avatar sx={{
              width: 52, height: 52,
              background: 'linear-gradient(135deg, #3B82F6, #6366F1)',
              fontWeight: 700, fontSize: '1.1rem',
              boxShadow: '0 4px 14px rgba(99,102,241,0.4)'
            }}>
              {initials}
            </Avatar>
            <Box>
              <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
                <DashboardIcon sx={{ color: 'rgba(255,255,255,0.6)', fontSize: 16 }} />
                <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)', fontWeight: 500, letterSpacing: 1.5, textTransform: 'uppercase' }}>
                  Dashboard
                </Typography>
              </Stack>
              <Typography variant="h5" sx={{ fontWeight: 800, color: '#fff', lineHeight: 1.2, mb: 0.5 }}>
                Welcome, {firstNameCapitalized}
              </Typography>
              <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)' }}>
                  {today}
                </Typography>
                <Chip
                  label={roleConfig.label}
                  size="small"
                  style={{
                    backgroundColor: roleConfig.bg,
                    color: roleConfig.color,
                    fontWeight: 600,
                    fontSize: '0.7rem',
                    backdropFilter: 'blur(4px)',
                    border: '1px solid rgba(255,255,255,0.2)'
                  }}
                />
              </Stack>
            </Box>
          </Stack>

          {/* Right: Action buttons */}
          <Stack direction="row" spacing={1.5} flexShrink={0}>
            <Button
              variant="contained"
              component={Link}
              to="/projects"
              startIcon={<AccountTreeIcon />}
              sx={{
                bgcolor: 'rgba(255,255,255,0.15)',
                color: '#fff',
                border: '1px solid rgba(255,255,255,0.25)',
                backdropFilter: 'blur(4px)',
                fontWeight: 600,
                px: 2.5,
                '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' },
                boxShadow: 'none',
                fontSize: { xs: '0.75rem', sm: '0.875rem' }
              }}
            >
              All Projects
            </Button>
            <Button
              variant="contained"
              component={Link}
              to="/tasks"
              startIcon={<AssignmentIcon />}
              sx={{
                bgcolor: '#3B82F6',
                color: '#fff',
                fontWeight: 600,
                px: 2.5,
                '&:hover': { bgcolor: '#2563EB' },
                boxShadow: '0 4px 14px rgba(59,130,246,0.4)',
                fontSize: { xs: '0.75rem', sm: '0.875rem' }
              }}
            >
              {t('DAFTAR TUGAS')}
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default DashboardHeader;
